import ReactDOM from 'react-dom';
// reduxを使うためのインポート
import {Provider} from 'react-redux';
import store from './reducks/store/store';
import App from './App';
import './index.css';
import {Toaster} from 'react-hot-toast';
import {registerLocale} from "react-datepicker";
import ja from "date-fns/locale/ja";
import {BrowserRouter} from 'react-router-dom';

registerLocale("ja", ja);

ReactDOM.render(
  <Provider store={store}>
    {/* <BrowserRouter history={history}> */}
    <BrowserRouter>
      <App />
      <Toaster
        position='top-center'
        toastOptions={{
          duration: 5000,
        }}
      />
    </BrowserRouter>
  </Provider>,
  document.getElementById('root')
);
